/**
 * #170 · El stock de XYVONA como pestaña de Etiquetas.
 *
 * La pantalla es la de siempre (`hq/StockPage`); lo que cambia es dónde está.
 * El módulo de etiquetas admite `analyst` de cualquier marca, pero el stock es
 * del back-office y de nadie más: a quien no sea XYVONA se le muestra "no
 * existe", que es lo mismo que le diría la API con su 403 pero sin un error
 * donde debería haber una pantalla.
 */
import type { ReactNode } from 'react';

import { useAuth } from '@/auth/useAuth';
import { BACKOFFICE_SLUG } from '@/layout/nav';
import { StockPage } from '../hq/StockPage';
import { NotFoundPage } from '../NotFoundPage';
import { LabelsTabs } from './LabelsTabs';

export function LabelsStockPage(): ReactNode {
  const { claims } = useAuth();
  if (claims?.tenant !== BACKOFFICE_SLUG) return <NotFoundPage />;
  return (
    <div className="mx-auto max-w-7xl space-y-4">
      <LabelsTabs active="stock" />
      <StockPage />
    </div>
  );
}
